import { render, staticRenderFns } from "./App.vue.js?vue&type=template&id=bdcde09a!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.4.11_@swc+helpers@0.5.17__webpack@5._1c4162b7d48aa5b46a78bee0ed0244ca/node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=bdcde09a"
import script from "./App.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.4.11_@swc+helpers@0.5.17__webpack@5._1c4162b7d48aa5b46a78bee0ed0244ca/node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=script&lang=js"
export * from "./App.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.4.11_@swc+helpers@0.5.17__webpack@5._1c4162b7d48aa5b46a78bee0ed0244ca/node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.4.11_@swc+helpers@0.5.17__webpack@5._1c4162b7d48aa5b46a78bee0ed0244ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdcde09a')) {
      api.createRecord('bdcde09a', component.options)
    } else {
      api.reload('bdcde09a', component.options)
    }
    module.hot.accept("./App.vue.js?vue&type=template&id=bdcde09a!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.4.11_@swc+helpers@0.5.17__webpack@5._1c4162b7d48aa5b46a78bee0ed0244ca/node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=bdcde09a", function () {
      api.rerender('bdcde09a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/app/components/App.vue"
export default component.exports